const DELIMITER_TOKENS = [
  ["\\(", "\uE000"],
  ["\\)", "\uE001"],
  ["\\[", "\uE002"],
  ["\\]", "\uE003"],
];

export function preserveMathDelimiters(content) {
  return DELIMITER_TOKENS.reduce(
    (value, [delimiter, token]) => value.replaceAll(delimiter, token),
    String(content || "")
  );
}

export function restoreMathDelimiters(content) {
  return DELIMITER_TOKENS.reduce(
    (value, [delimiter, token]) => value.replaceAll(token, delimiter),
    String(content || "")
  );
}
